import { generateID } from 'app/utils/functions';
import { colors } from 'app/utils/colors';

const drop = {
  namespaced: true,
  state: {
    drops: [
      {
        name: 'Drop 12',
        url: './static/dashboard/1.jpg',
        id: 1,
        date: '',
        type: 'video',
        tag: {
          name: 'Fun',
          id: 3,
          color: colors[0],
        },
      },
      {
        name: 'Drop 11',
        url: './static/dashboard/2.jpg',
        id: 2,
        date: '',
        type: 'video',
        tag: {
          name: 'Fun',
          id: 3,
          color: colors[0],
        },
      },
      {
        name: 'Drop 112',
        url: './static/dashboard/3.jpg',
        id: 3,
        date: '',
        type: 'video',
        tag: {
          name: 'Fun',
          id: 3,
          color: colors[0],
        },
      },
      {
        name: 'Drop 1112',
        url: './static/dashboard/4.jpg',
        id: 4,
        date: '',
        type: 'video',
        tag: {
          name: 'Facebook',
          id: 4,
          color: colors[1],
        },
      },
      {
        name: 'Drop 1112',
        url: './static/dashboard/5.jpeg',
        id: 5,
        date: '',
        type: 'video',
        tag: {
          name: 'Facebook',
          id: 4,
          color: colors[1],
        },
      },
      {
        name: 'Drop 1112',
        url: './static/dashboard/6.png',
        id: 6,
        date: '',
        type: 'video',
        tag: {
          name: 'Facebook',
          id: 4,
          color: colors[1],
        },
      },
      {
        name: 'Drop 1112',
        url: './static/dashboard/7.jpeg',
        id: 7,
        date: '',
        type: 'video',
        tag: {
          name: 'Facebook',
          id: 4,
          color: colors[1],
        },
      },

    ],
  },
  mutations: {
    edit(state, drop) {
      drop = { ...drop };
      for (let i = 0; i < state.drops.length; i++) {
        if (state.drops[i].id == drop.id) {
          for (let key in state.drops[i]) {
            state.drops[i][key] = drop[key];
          }
          break;
        }
      }
    },
    addDrop(state, drop) {
      drop.id = generateID();
      // if (state.tags.length == 0) {
      //   state.selectedTagId = tag.id;
      // }
      state.drops.push({ ...drop });
    },
    delete(state, id) {
      for (let i = 0; i < state.drops.length; i++) {
        if (state.drops[i].id == id) {
          state.drops.splice(i, 1);
          break;
        }
      }
    },
  },
  actions: {
    edit(context, payload) {
      context.commit('edit', payload);
    },
    addDrop(context, payload) {
      context.commit('addDrop', payload);
    },
    delete(context, id) {
      context.commit('delete', id);
    },
  },

  getters: {
    drops: state => {
      return state.drops;
    },
  },
};

export { drop };
